import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { makeStyles } from '@material-ui/styles';
import { Typography, Button, IconButton } from '@material-ui/core';
import CookieIcon   from '@material-ui/icons/LocalOffer';
import CloseIcon    from '@material-ui/icons/Close';
import ShieldIcon   from '@material-ui/icons/Security';

const BRAND = '#682622';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    bottom: 24,
    right: 24,
    width: 340,
    zIndex: 2000,
    backgroundColor: '#fff',
    borderRadius: 16,
    boxShadow: '0 8px 32px rgba(0,0,0,0.14), 0 2px 8px rgba(0,0,0,0.08)',
    border: '1px solid #e8ecef',
    overflow: 'hidden',
    animation: '$slideUp 0.3s ease-out',
  },
  '@keyframes slideUp': {
    from: { opacity: 0, transform: 'translateY(16px)' },
    to:   { opacity: 1, transform: 'translateY(0)' },
  },

  /* Coloured top strip */
  strip: {
    background: `linear-gradient(135deg, ${BRAND} 0%, #4e1b18 100%)`,
    padding: theme.spacing(1.5, 2),
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  },
  stripLeft: { display: 'flex', alignItems: 'center', gap: 8 },
  stripIcon: {
    width: 32, height: 32, borderRadius: 8,
    backgroundColor: 'rgba(255,255,255,0.15)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    '& svg': { fontSize: '1rem', color: '#fff' },
  },
  stripTitle: { fontWeight: 700, fontSize: '0.88rem', color: '#fff' },
  closeBtn:   { color: 'rgba(255,255,255,0.7)', padding: 4, '&:hover': { color: '#fff', backgroundColor: 'rgba(255,255,255,0.12)' } },

  /* Body */
  body: { padding: theme.spacing(2, 2.5) },
  message: { fontSize: '0.82rem', color: '#546e7a', lineHeight: 1.6 },
  link: { color: BRAND, fontWeight: 600, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } },

  /* Privacy chips */
  chips: { display: 'flex', gap: 8, marginTop: theme.spacing(1.5), flexWrap: 'wrap' },
  chip: {
    display: 'inline-flex', alignItems: 'center', gap: 4,
    backgroundColor: `${BRAND}10`, color: BRAND,
    borderRadius: 20, padding: '3px 10px',
    fontSize: '0.68rem', fontWeight: 600,
    '& svg': { fontSize: '0.75rem' },
  },

  /* Actions */
  actions: {
    display: 'flex', gap: 8,
    padding: theme.spacing(0, 2.5, 2.5),
  },
  agreeBtn: {
    flex: 1,
    backgroundColor: BRAND, color: '#fff', fontWeight: 600,
    borderRadius: 8, textTransform: 'none', fontSize: '0.82rem',
    padding: theme.spacing(0.875, 0),
    '&:hover': { backgroundColor: '#4e1b18' },
  },
  declineBtn: {
    flex: 1,
    color: '#78909c', fontWeight: 600, borderRadius: 8,
    textTransform: 'none', fontSize: '0.82rem', border: '1px solid #e0e0e0',
    '&:hover': { backgroundColor: '#f5f5f5' },
  },
}));

const CookiesNotification = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!Cookies.get('consent')) setOpen(true);
  }, []);

  const handleAgree = () => { Cookies.set('consent', 'true', { expires: 365 }); setOpen(false); };
  const handleClose = () => setOpen(false);

  if (!open) return null;

  return (
    <div className={classes.root}>
      {/* Header strip */}
      <div className={classes.strip}>
        <div className={classes.stripLeft}>
          <div className={classes.stripIcon}><CookieIcon /></div>
          <Typography className={classes.stripTitle}>Cookie Notice</Typography>
        </div>
        <IconButton className={classes.closeBtn} size="small" onClick={handleClose}>
          <CloseIcon style={{ fontSize: '1rem' }} />
        </IconButton>
      </div>

      {/* Body */}
      <div className={classes.body}>
        <Typography className={classes.message}>
          We use cookies to enhance your experience and analyse site usage.
          By continuing, you agree to our use of cookies.
        </Typography>

        <div className={classes.chips}>
          <span className={classes.chip}><ShieldIcon /> Secure & Private</span>
          <span className={classes.chip}><ShieldIcon /> No personal data sold</span>
        </div>
      </div>

      {/* Actions */}
      <div className={classes.actions}>
        <Button className={classes.declineBtn} variant="outlined" onClick={handleClose}>
          Decline
        </Button>
        <Button className={classes.agreeBtn} variant="contained" onClick={handleAgree}>
          Accept All
        </Button>
      </div>
    </div>
  );
};

export default CookiesNotification;
